import { render, staticRenderFns } from "./item-selector.vue?vue&type=template&id=42516ea1&scoped=true&"
import script from "./item-selector.vue?vue&type=script&lang=js&"
export * from "./item-selector.vue?vue&type=script&lang=js&"
import style0 from "./item-selector.vue?vue&type=style&index=0&id=42516ea1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42516ea1",
  null
  
)

export default component.exports